/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum GastherapySuspendAliases {
  AUTOCOMPLETE_ITEM_SUSPEND_REASON = 'autocomplete-item-suspend-reason',
  CONTENT_INFORMATION_HEADER = 'content-information-header',
  DATE_HOUR_FIELD = 'date-hour-field',
  DATE_HOUR_INPUT = 'date-hour-input',
  FETCH_GASTHERAPY_ITEM_REASON = 'fetch-gastherapy-item-reason',
  FIELD_REASON = 'field-reason',
  FORM_REASON = 'form-reason',
  GASTHERAPY_PANEL = 'gastherapy-panel',
  GASTHERAPY_SUSPEND_LAYOUT = 'gastherapy-suspend-layout',
  MAPPER_ITEM_SUSPEND_REASON = 'mapper-item-suspend-reason',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  TEXT_GASTHERAPY_DATE = 'text-gastherapy-date',
  TEXT_GASTHERAPY_INFORMATION = 'text-gastherapy-information',
  TEXT_GASTHERAPY_TITLE = 'text-gastherapy-title',
  TEXT_ITEM_SUSPEND_REASON = 'text-item-suspend-reason',
}
export { GastherapySuspendAliases };
